<template>
  <div>
    <AppPreloader v-if="vacancies.isFetching" />
    <VAlert v-else-if="vacancies.fetchError" type="error">
      {{ vacanciesList.fetchError }}
    </VAlert>
    <div v-else-if="vacancies.isFetched">
      <div v-if="vacancies.items.length > 0" class="vacancy-list-detail">
        <VacancyItem
          v-for="vacancy in vacancies.items"
          :key="vacancy.id"
          :vacancy="vacancy"
        />

        <template v-if="vacanciesMetaData && vacanciesMetaData.data.last_page > 1">
          <VPagination
            :value="page"
            :length="vacanciesMetaData.data.last_page"
            @input="loadPage($event)"
          />
        </template>
      </div>
      <div v-else>
        <div class="vacancy-list-empty">
          {{ $t('emptyVacancies') }}
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex';
import AppPreloader from '../AppPreloader.vue';
import VacancyItem from './VacancyItem.vue';

export default {
  name: 'ListVacancies',
  components: {
    VacancyItem,
    AppPreloader,
  },
  props: {
    id: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      page: 1,
      perPage: 15,
    };
  },
  computed: {
    ...mapState('vacanciesList', ['vacancies', 'vacanciesMetaData']),
  },
  watch: {
    vacancies(newValue) {
      if (newValue.fetchCode === 404) {
        this.$router.push({ name: '404' });
      }
    },
  },
  async created() {
    await this.fetch();
  },
  async serverPrefetch() {
    await this.fetch();
    if (this.vacancies.fetchError) {
      throw new Error(String(this.vacancies.fetchCode));
    }
  },
  methods: {
    async fetch() {
      await this.$store.dispatch('vacanciesList/fetchVacancies', {
        id: this.id,
        page: this.page,
        perPage: this.perPage,
      });
    },
    async loadPage(newPage) {
      this.page = newPage;
      await this.fetch();
    },
  },
};
</script>

<style lang="scss" scoped>
.vacancy-list-detail {
  background: #FFFFFF;
  box-shadow: 0 2px 0.5rem rgba(0, 0, 0, 0.16);
  border-radius: 0.625rem;
  padding: 0.375rem 2.5rem;
  margin-bottom: 1.25rem;
}
.vacancy-list-empty {
  background: #FFFFFF;
  box-shadow: 0 2px 0.5rem rgba(0, 0, 0, 0.16);
  border-radius: 0.625rem;
  padding: 1.125rem 1.375rem;
  margin-bottom: 1.25rem;
}
@media #{map-get($display-breakpoints, 'md-and-down')} {
  .vacancy-list-detail {
    padding: 0.5rem 1.75rem;
  }
}
@media #{map-get($display-breakpoints, 'xs-only')} {
  .vacancy-list-detail {
    padding: 0.5rem 1rem;
  }
}

</style>

<i18n locale="en" lang="yaml">
emptyVacancies: The employer currently has no open jobs
</i18n>

<i18n locale="ru" lang="yaml">
emptyVacancies: У работодателя в настоящий момент нет активных вакансий
</i18n>
